import dayjs from "dayjs";
import React from "react";

function Messages({ className, children, messageData }) {
  return (
    <div>
      <div className="flex items-center">
        {messageData?.author?.profile ? (
          <img
            src={messageData?.author?.profile}
            className="w-[30px] h-[30px] rounded-full mr-2"
          />
        ) : (
          <div className="w-[30px] h-[30px] rounded-full mr-2 bg-[#9797BE] uppercase flex items-center justify-center font-medium text-[#fff] uppercase">
            {messageData?.author?.name?.charAt(0)}
          </div>
        )}
        <p className="m-0 mr-2 text-[#30307D] font-semibold capitalize">
          {messageData?.author?.name}
        </p>
        <p className="text-[#9797BE] m-0 text-[10px]">
          {dayjs(messageData?.created_at).format("DD MMM YYYY, hh:mmA")}
        </p>
      </div>
      <div
        className={`p-2 mt-2 ml-8 mb-4 bg-[#F9F9FF] w-fit p-xs font-medium text-[#9797BE] rounded-[6px] ${className}`}
      >
        {children}
      </div>
    </div>
  );
}

export default Messages;
